import Carousel from "react-multi-carousel";
import { Col, Container, Row } from "react-bootstrap";

// svgs imports
import bemIcon from "../../assets/images/skills/bem.svg"
import cssIcon from "../../assets/images/skills/css.svg"
import gitIcon from "../../assets/images/skills/git.svg";
import htmlIcon from "../../assets/images/skills/html.svg"
import javaIcon from "../../assets/images/skills/java.svg"
import jsIcon from "../../assets/images/skills/javascript.svg"
import pythonIcon from "../../assets/images/skills/python.svg"
import reactIcon from "../../assets/images/skills/react.svg"
import scssIcon from "../../assets/images/skills/scss.svg"
import springBootIcon from "../../assets/images/skills/springboot.svg"
import firebaseImg from "../../assets/images/skills/firebase.svg"
import sqlImg from "../../assets/images/skills/sql.svg"
import cypressImg from "../../assets/images/skills/cypress.svg"
import jestImg from "../../assets/images/skills/jest.svg"
import agileImg from "../../assets/images/skills/agile.svg"

import "./Skills.scss";
import "react-multi-carousel/lib/styles.css";

const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    largeDesktop: {
      breakpoint: { max: 3000, min: 1400 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1400, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  
  return (
    <div className="skill" id="skills">
      <Container>
        <Row>
          <Col>
            <div className="skill-box">
              <h2>Skills</h2>
              <p>
                After two bootcamps for coding, I have gained a lot of skills, that will allow me to have a great head start in becoming a Junior Developer. I am familiar with TDD in general, and the following technologies:
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                dotListClass="custom-dot-list-style"
                className="skill-slider"
                keyboard={true}
              >
                <div className="item">
                  <img src={htmlIcon} alt="html icon" />
                  <h5>HTML</h5>
                </div>
                <div className="item">
                  <img src={cssIcon} alt="css icon" />
                  <h5>CSS</h5>
                </div>
                <div className="item">
                  <img src={jsIcon} alt="js icon" />
                  <h5>JavaScript</h5>
                </div>
                <div className="item">
                  <img src={reactIcon} alt="react icon" />
                  <h5>React</h5>
                </div>
                <div className="item">
                  <img src={javaIcon} alt="java icon" />
                  <h5>Java</h5>
                </div>
                <div className="item">
                  <img src={springBootIcon} alt="sb icon" />
                  <h5>Spring Boot</h5>
                </div>
                <div className="item">
                  <img src={pythonIcon} alt="python icon" />
                  <h5>Python</h5>
                </div>
                <div className="item">
                  <img src={bemIcon} alt="bem icon" />
                  <h5>BEM</h5>
                </div>
                <div className="item">
                  <img src={gitIcon} alt="git icon" />
                  <h5>GIT</h5>
                </div>
                <div className="item">
                  <img src={scssIcon} alt="scss icon" />
                  <h5>SCSS</h5>
                </div>
                <div className="item">
                  <img src={firebaseImg} alt="scss icon" />
                  <h5>Firebase</h5>
                </div>
                <div className="item">
                  <img src={sqlImg} alt="scss icon" />
                  <h5>MySQL</h5>
                </div>
                <div className="item">
                  <img src={cypressImg} alt="scss icon" />
                  <h5>Cypress</h5>
                </div>
                <div className="item">
                  <img src={jestImg} alt="scss icon" />
                  <h5>Jest</h5>
                </div>
                <div className="item">
                  <img src={agileImg} alt="scss icon" />
                  <h5>Agile</h5>
                </div>

              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Skills;
